<app>

    <nav-bar
            user="{opts.user}"
            show-filter-bar="{false}"

    ></nav-bar>


    <!--  hero banner   -->
    <section class="demo-hero-5" data-pages="parallax"
             data-pages-bg-image="http://www.youthincmag.com/wp-content/uploads/2017/04/blog.jpg">
        <div class="container-xs-height full-height hero-gradient">
            <div class="col-xs-height col-middle text-center">
                <h1 class="text-white inner bold">Aeroviewer for News portals – Blogs – on line media</h1>
            </div>
        </div>
    </section>
    <!--  End of hero banner   -->

    <!-- Section Title -->
    <section class="p-b-20 p-t-20">
        <div class="container">
            <div class="row">
                <div class="col text-center">
                    <p class="h1 block-title m-b-0">AEROVIEWER can offer a rich multilayered (video and photos) visual
                        content</p>
                    <p class="h2 m-t-5 light">
                        for all possible Destinations and vacation proposals a news portal might need for its “travel”
                        editorial.
                    </p>
                </div>
            </div>
        </div>
    </section>
    <!-- End section title -->


    <!-- Contributors section#1 -->
    <section class="bg-master-lightest p-b-60 p-t-60">
        <div class="container">
            <div class="md-p-l-20 md-p-r-20 xs-no-padding">
                <h5 class="block-title hint-text no-margin">The same applies</h5>
                <div class="row">
                    <div class="col">
                        <p class="h1 m-t-5">to the travel / tourism blogs also.
                            Suppose there is a post for the TOP 10 beaches in Mediterranean Sea or for the less known
                            Italian
                            island Ponza. </p>

                        <p>Obviously the article will mention the top beaches of the island.
                            Suppose the editor likes to have a video for the top-5 beaches on the island and the two
                            most known marinas. <br><br> In less than 10 minutes can create his own videos presenting
                            the top-5
                            beaches of the island and the top-2 marinas.</p>
                    </div>
                    <div class="col no-padding xs-p-l-15 xs-p-r-15">
                        <div class="p-l-35 md-p-l-5">
                            <img class="image-responsive-height" src="/static/web/assets/images/blog-01.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <avr-footer></avr-footer>

    <script>

        // import components

        import '../../components/nav-bar/nav-bar.tag.html';
        import '../../components/avr-footer/avr-footer.tag.html';


        // app instance
        const app = this;

    </script>
</app>


// WEBPACK FOOTER //
// avr_eshop/frontend/apps/blogs/app.tag.html